"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  num: "01",
  title: "Structured Planning",
  description: "We utilise industry-leading software to define project benchmarks, safety protocols, and compliance requirements from day one."
}, {
  num: "02",
  title: "Transparent Execution",
  description: "Real-time communication and streamlined processes ensure every phase of construction is delivered with precision and accountability."
}, {
  num: "03",
  title: "Quality Completion",
  description: "Rigorous inspections and defect management ensure high-quality handovers that meet all structural and functional standards."
}];
export default function ThePathToSuccess() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223571" id="our-accountability-framework" className="bg-background py-24 sm:py-32 overflow-hidden">
      <div className="mx-auto max-w-5xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center mb-16 md:mb-24">
          <h2 className="text-sm/6 font-semibold text-primary font-default tracking-widest uppercase">
            How We Do It
          </h2>
          <p className="mt-2 text-3xl font-bold tracking-tight text-foreground sm:text-4xl font-default uppercase">
            Our Accountability Framework
          </p>
          <p className="mt-4 text-lg leading-8 text-muted-foreground font-default">
            We combine industry-leading project management software with transparent communication to deliver efficient and accountable project outcomes.
          </p>
        </div>

        <div ref={ref} className={`relative transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="hidden md:block absolute top-8 left-[16.66%] right-[16.66%] h-[2px] border-t-2 border-dashed border-primary/30 z-0" aria-hidden="true" />

          {}
          <div className="md:hidden absolute left-8 top-8 bottom-8 w-[2px] border-l-2 border-dashed border-primary/30 z-0" aria-hidden="true" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 relative z-10">
            {steps.map((step, i) => <div key={step.num} data-index={i} className="relative flex flex-row md:flex-col items-start md:items-center gap-6 md:gap-0 group">
                {}
                <div className="flex size-16 shrink-0 items-center justify-center rounded-lg bg-primary text-primary-foreground shadow-md transition-transform duration-300 group-hover:scale-105">
                  <span className="text-xl font-bold font-mono">
                    {step.num}
                  </span>
                </div>

                {}
                <div className="pt-3 md:pt-0 md:mt-8 md:text-center flex-1">
                  <h3 className="text-base font-bold text-foreground font-default uppercase tracking-wide">
                    {step.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-muted-foreground font-default">
                    {step.description}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}